import { useRender } from '@base-ui/react/use-render'
import clsx from 'clsx'
import React, { ComponentProps } from 'react'

import { ImageWithPins } from '@Components/Image'
import { Button } from '@CoreComponents/Buttons/Button'
import { PagePresentation } from '@Generated/graphql'
import { Image, ImagePin } from '@Globals/Image'
import { useTranslation } from '@Globals/Translations'

import styles from './TilesCard.module.scss'

export const TilesCardLook = ({
  ambassadorHandle,
  buttonLabel,
  cardAspectRatio,
  cardSize,
  cardVariant,
  className,
  image,
  pins,
  presentation = PagePresentation.Full,
  render,
  renderButtonAsText = false,
  sizes,
  ...props
}: {
  ambassadorHandle?: string
  buttonLabel?: string
  cardAspectRatio: string
  cardSize: string
  cardVariant: string
  image: Image
  pins?: ImagePin[] | null
  presentation?: PagePresentation
  render?: useRender.RenderProp
  renderButtonAsText?: boolean
  sizes?: string
} & ComponentProps<'div'>) => {
  const { t } = useTranslation()

  return useRender({
    defaultTagName: 'div',
    render,
    props: {
      ...props,
      children: (
        <>
          <ImageWithPins image={image} pins={pins} sizes={sizes} />
          <div className={styles.content}>
            {ambassadorHandle && (
              <div className={styles.ambassadorHandle}>
                {ambassadorHandle}
              </div>
            )}
            {(buttonLabel || !pins || pins.length === 0) && (
              <div className={styles.buttonContainer}>
                <Button
                  className={styles.button}
                  innerSpacing="medium"
                  theme="white"
                  type={!renderButtonAsText ? 'button' : undefined}
                >
                  {buttonLabel || t('common:SHOP_THE_LOOK')}
                </Button>
              </div>
            )}
          </div>
        </>
      ),
      className: clsx(
        styles.look,
        styles[cardVariant],
        styles[cardSize],
        styles[cardAspectRatio],
        styles[presentation.toLowerCase()],
        className,
      ),
    },
  })
}
